const MARKET_STORAGE_KEY = 'liviiart_market';

const MARKET_CURRENCY = {
    uk: 'gbp',
    latvia: 'eur',
};

const CURRENCY_SYMBOL = {
    eur: '€',
    gbp: '£',
};

const DEFAULT_CURRENCY = 'eur';

export const getStoredMarket = () => {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(MARKET_STORAGE_KEY)?.toLowerCase() || null;
};

export const resolveCurrency = ({ market, currency } = {}) => {
    if (currency) return currency.toLowerCase();
    const activeMarket = (market || getStoredMarket() || '').toLowerCase();
    return MARKET_CURRENCY[activeMarket] || DEFAULT_CURRENCY;
};

export const getCurrencySymbol = (code) => CURRENCY_SYMBOL[code?.toLowerCase()] || CURRENCY_SYMBOL[DEFAULT_CURRENCY];

export const formatPrice = (valueInCents, opts = {}) => {
    const cents = typeof valueInCents === 'number' ? valueInCents : 0;
    const currencyCode = resolveCurrency(opts);
    const symbol = getCurrencySymbol(currencyCode);
    return `${symbol}${(cents / 100).toFixed(2)}`;
};

export { MARKET_STORAGE_KEY };
